var components
try {
  components = {
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
    uLoadmore: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-loadmore/u-loadmore" */ "uview-ui/components/u-loadmore/u-loadmore.vue"
      )
    },
    uPicker: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-picker/u-picker" */ "uview-ui/components/u-picker/u-picker.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = ["3"].includes(_vm.typeId)
  var g1 = ["1"].includes(_vm.typeId)
  var l0 = _vm.__map(_vm.list, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var g2 = [0].includes(item.type)
    var m0 = g2 ? _vm.titleType(item.type) : null
    var m1 = g2 ? _vm.userType(item.memberType) : null
    var g3 = g2 ? item.happenTime.substring(0, 16) : null
    var g4 = g2 ? item.submitDate.substring(0, 16) : null
    var g5 = !g2 ? [3].includes(item.type) : null
    var m2 = !g2 && g5 ? _vm.titleType(item.type) : null
    var g6 = !g2 && g5 ? item.happenTime.substring(0, 16) : null
    var g7 = !g2 && g5 ? item.submitDate.substring(0, 16) : null
    var g8 = !g2 && !g5 ? item.createDate.substring(0, 16) : null
    var g9 = [3, 4, 5].includes(item.status)
    var g10 = !g9 ? [0, 1, 2].includes(item.status) : null
    return {
      $orig: $orig,
      g2: g2,
      m0: m0,
      m1: m1,
      g3: g3,
      g4: g4,
      g5: g5,
      m2: m2,
      g6: g6,
      g7: g7,
      g8: g8,
      g9: g9,
      g10: g10,
    }
  })
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.show = true
    }
    _vm.e1 = function ($event) {
      _vm.show1 = true
    }
    _vm.e2 = function ($event) {
      return _vm.$refs.pengTree._show()
    }
    _vm.e3 = function ($event) {
      return _vm.$refs.pengTree1._show()
    }
    _vm.e4 = function ($event) {
      _vm.show = false
    }
    _vm.e5 = function ($event) {
      _vm.show1 = false
    }
    _vm.e6 = function ($event) {
      return _vm.$refs.pengTree._hide()
    }
    _vm.e7 = function ($event) {
      return _vm.$refs.pengTree._hide()
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }